const TRIALS_TRACKING_EVENTS = {
  signup: {
    action: true,
    clicked: true,
    error: true,
    viewed: true,
    formFieldFilled: true,
  },
  trials: {
    accountInfo: {
      emailFieldFilled: true,
      error: true,
      nextClicked: true,
      passwordFieldFilled: true,
      phoneFieldFilled: true,
      visited: true,
    },
    accountVerification: {
      verificationPageViewed: true,
      verificationSuccessful: true,
      verificationNotSuccessful: true,
      resendCodeClicked: true,
      resendSuccessful: true,
      resendNotSuccessful: true,
      sendVerificationSuccessful: true,
      sendVerificationError: true,
      updatePhoneNumber: true,
    },
    businessInfo: {
      addressFieldFilled: true,
      addressOptionalFieldFilled: true,
      cityFieldFilled: true,
      countryFieldFilled: true,
      enterManualClick: true,
      fieldError: true,
      gmbClick: true,
      nameFieldFilled: true,
      nextClicked: true,
      phoneFieldFilled: true,
      stateFieldFilled: true,
      visited: true,
      zipFieldFilled: true,
    },
    googleLogin: {
      clicked: true,
      redirectExisting: true,
      succeeded: true,
    },
    suggestedEmail: {
      clicked: true,
    },
    startTrial: {
      cardExpirationFieldFilled: true,
      cardNumberFieldFilled: true,
      cardSecurityCodeFieldFilled: true,
      error: true,
      fieldError: true,
      firstNameFieldFilled: true,
      lastNameFieldFilled: true,
      postalCodeFieldFilled: true,
      startTrialClicked: true,
      startTrialSubmitted: true,
      success: true,
    },
    createAccountError: {
      visited: true,
      tryAgainClicked: true,
    },
    userInviteExists: {
      viewed: true,
      googleClicked: true,
      yahooClicked: true,
      icloudClicked: true,
      outlookClicked: true,
      aolClicked: true,
    },
    profile: {
      firstNameFieldFilled: true,
      lastNameFieldFilled: true,
      phoneFieldFilled: true,
      error: true,
      visited: true,
      nextClicked: true,
    },
    version: true,
  },
  accountProvisioning: {
    duration: true,
  },
};

export default TRIALS_TRACKING_EVENTS;
